/**
 * The member's order lists keep the portal's filter names in the address bar;
 * the endpoints the shop built name them their own way and want whole
 * timestamps (#2279, #2280).
 */
const ENDPOINT_PARAMS: Record<string, string> = {
    supplierAccountId: 'supplierIds',
    customerContactId: 'customerContactIds',
};

/** The page size the member's lists show when the address names none. */
export const MEMBER_LIST_LIMIT = 50;

export const memberOrderParams = (searchParams: URLSearchParams): URLSearchParams => {
    const params = new URLSearchParams();

    // The endpoint pages by 30 unless told otherwise, while the list counted
    // its pages by 50 — a third of the orders was out of reach (R-166).
    params.set('limit', String(MEMBER_LIST_LIMIT));

    searchParams.forEach((value, key) => {
        if ('createdAtFrom' === key || 'createdAtUntil' === key) {
            params.set(key, /T/.test(value) ? value : `${value}T00:00:00+00:00`);

            return;
        }

        params.set(ENDPOINT_PARAMS[key] ?? key, value);
    });

    return params;
};
